import { GamingLayout } from "components/Layout.tsx/GamingLayout "

export const TestPage = () => {
    return <GamingLayout heading='test'>
        <p>test</p>
    </GamingLayout>
}